import React, { useCallback, useState } from 'react';
import { RndWrapper } from '../base/RndModal';
import { useAsyncEffect, useEventListener } from 'ahooks';
import { useDebouncedCallback } from '@mantine/hooks';
import ModalLayout from '../base/RndModal/ModalLayout';
import SideBar from './SideBar';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import { useProjectState } from '@starflow/app/store';
import { calcType } from '../../../../constants';
import loadingImg from '../../assets/loading.png';
import DownIcon from '../../assets/download.svg';
import styles from './index.module.scss';
import { requestByGet } from '@shakkerai/services';
import { pickPresetData } from '../../../../components/flow/utils';

const DEF_SIZE = 20;

const PresetModels = React.memo(() => {
  const [loading, setLoading] = useState(false);
  const [presetData, setPresetData] = useState([]);
  const [cols, setCols] = useState(4);

  const units = useProjectState('units');
  const nodeMap = useProjectState('nodeMap');

  const calcCols = useCallback(() => {
    switch (true) {
      case innerWidth < 900:
        setCols(2);
        break;
      case innerWidth >= 900 && innerWidth <= 1200:
        setCols(3);
        break;
      case innerWidth >= 1200 && innerWidth <= 1500:
        setCols(4);
        break;
      case innerWidth >= 1500 && innerWidth <= 1700:
        setCols(5);
        break;
      case innerWidth >= 1700 && innerWidth <= 1920:
        setCols(6);
        break;
      case innerWidth > 1920:
        setCols(7);
        break;
      default:
    }
  }, [cols, innerWidth, setCols]);

  useAsyncEffect(async () => {
    setLoading(true);
    calcCols();
    try {
      const res = await requestByGet(`/api/canva/workspace/preset/flow?size=${DEF_SIZE}`);
      if (res.code === 0) {
        setPresetData(res.data);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }, []);

  const resizeWindow = useDebouncedCallback(() => {
    calcCols();
  }, 200);

  useEventListener('resize', resizeWindow);
  return (
    <RndWrapper isShowCloseBtn={false}>
      <ModalLayout sideBar={<SideBar />} title="工作流预设">
        <div className="flex-1 flex flex-wrap bg-white py-5 pl-5 h-full cursor-default">
          {loading ? (
            <div className="w-full h-full">
              <img
                style={{ margin: '200px auto' }}
                className={`w-[30px] h-[30px] object-cover ${styles['animate-spin-ckpt']}`}
                src={loadingImg}
                alt=""
              />
            </div>
          ) : (
            presetData.map(({ flowFile, name, imageUrl, type }, idx) => {
              return (
                <>
                  <div
                    onClick={() => pickPresetData(flowFile, nodeMap, units)}
                    className="flex-shrink-0 bg-white cursor-pointer mb-4 pr-5"
                    key={idx}
                    style={{
                      width: `${100 / cols}%`,
                      aspectRatio: '185/272',
                    }}
                  >
                    <img
                      src={convert2CompressedUrl(imageUrl, 800)}
                      alt=""
                      className="w-full rounded-t-[4px]"
                      style={{ aspectRatio: '185/211' }}
                    />
                    <div
                      className="bg-white rounded-b-[4px] p-3"
                      style={{ border: '1px solid #eee', borderTop: '0px solid transparent', aspectRatio: '185/61' }}
                    >
                      <span>{name}</span>
                      <div className="flex items-center justify-between mt-1">
                        <div className="text-[#B3B3B3]">{calcType(type)}</div>
                        <div className="flex items-center cursor-pointer">
                          <img src={DownIcon} alt="upload" className="w-[14px] h-[14px]" />
                          <span className="text-[#777] ml-1">使用</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          )}
        </div>
      </ModalLayout>
    </RndWrapper>
  );
});
export default PresetModels;
